package com.tovtalk.ui.screen.onboarding

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import com.tovtalk.utils.strings.StringProvider

@Composable
fun NotificationsPermissionScreen(
    onRequestPermission: () -> Unit,
    onAdvance: () -> Unit,
    onBack: (() -> Unit)? = null,
) {
    OnboardingLayout(
        progressCurrent = 1,
        progressTotal = 4,
        onSkip = onAdvance,
        onBack = onBack,
        ctaText = StringProvider.get("onboarding_notif_enable"),
        onCta = {
            onRequestPermission()
            onAdvance()
        },
        headerContent = {
            OnboardingHeader(
                eyebrow = "",
                title = StringProvider.get("onboarding_notif_title"),
                subtitle = StringProvider.get("onboarding_notif_subtitle"),
            )
        },
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(260.dp)
                .padding(horizontal = 24.dp),
        ) {
            FloatingNotification(
                title = StringProvider.get("onboarding_notif_mock_1_title"),
                body = StringProvider.get("onboarding_notif_mock_1_body"),
                phase = 0f,
            )
            FloatingNotification(
                title = StringProvider.get("onboarding_notif_mock_2_title"),
                body = StringProvider.get("onboarding_notif_mock_2_body"),
                phase = 0.5f,
            )
        }
    }
}

@Composable
private fun FloatingNotification(
    title: String,
    body: String,
    phase: Float,
) {
    val transition = rememberInfiniteTransition(label = "notif-float")
    val progress by transition.animateFloat(
        initialValue = phase,
        targetValue = phase + 1f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 5200, easing = LinearEasing),
        ),
        label = "notif-progress",
    )

    val wrapped = progress % 1f
    val travelDp = 200f
    val translationY = (1f - wrapped) * travelDp - travelDp / 2f
    val alpha = when {
        wrapped < 0.15f -> wrapped / 0.15f
        wrapped > 0.85f -> (1f - wrapped) / 0.15f
        else -> 1f
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .graphicsLayer {
                this.translationY = translationY * density
                this.alpha = alpha
            },
    ) {
        MockNotificationCard(title = title, body = body, rotationDegrees = 0f)
    }
}
